import {utils} from 'xlsx';

const SUMMARY_COLUMN_WIDTHS = [34, 14, 14, 14, 10];
const DETAIL_COLUMN_WIDTHS = [34, 50, 18, 14, 12, 12, 12, 10, 8, 60];

const summaryRow = (seller, t) => ({
    [t('product_detail.competitor')]: seller.name,
    [t('price_violation.violators')]: seller.below_map,
    [t('product_detail.equal_map')]: seller.equal_map,
    [t('product_detail.above_map')]: seller.above_map,
    [t('table_headers.total')]: seller.below_map + seller.equal_map + seller.above_map,
});

const detailRow = (product, state, t) => ({
    [t('product_detail.competitor')]: state.name,
    [t('product.product_name')]: product.name,
    [t('product.product_code')]: product.product_code,
    [t('price_violation.map')]: Number(product.min_value),
    [t('product_detail.price')]: state.value,
    [t('price_violation.gap')]: state.gap,
    [t('price_violation.difference')]: state.difference,
    [t('product.currency')]: state.currency,
    [t('product_detail.stock')]: state.stock,
    [t('suggestion.url')]: state.product_url,
});

const addSheet = (workbook, rows, name, columnWidths) => {
    const sheet = utils.json_to_sheet(rows);
    sheet['!cols'] = columnWidths.map(wch => ({wch}));
    utils.book_append_sheet(workbook, sheet, name);
};

export const buildSellersSummaryWorkbook = (sellers, violations, t) => {
    const ordered = [...sellers].sort((first, second) => second.below_map - first.below_map);
    const sellerOrder = new Map(ordered.map((seller, index) => [seller.name, index]));

    const detail = violations
        .flatMap(product => product.competitor_violation_states
            .filter(state => state.map_violated && sellerOrder.has(state.name))
            .map(state => ({product, state})))
        .sort((first, second) =>
            sellerOrder.get(first.state.name) - sellerOrder.get(second.state.name)
            || (first.product.name || '').localeCompare(second.product.name || ''));

    const workbook = utils.book_new();
    addSheet(workbook, ordered.map(seller => summaryRow(seller, t)), t('dashboard.sellers_summary'), SUMMARY_COLUMN_WIDTHS);
    addSheet(workbook, detail.map(({product, state}) => detailRow(product, state, t)), t('dashboard.list_of_violations'), DETAIL_COLUMN_WIDTHS);
    return workbook;
};
